import * as documentSubtypes from '../constants/documentSubtypes';

const text = {
  [documentSubtypes.CP_575]: 'CP 575',
  [documentSubtypes.LTR_147C]: '147C',
  [documentSubtypes.SS4]: 'SS-4',
  [documentSubtypes.W2]: 'W2',
  [documentSubtypes.WELLS_FARGO]: 'Wells Fargo',
  [documentSubtypes.BANK_OF_AMERICA]: 'Bank of America',
  [documentSubtypes.CHASE_BANK]: 'Chase Bank',
  [documentSubtypes.PNC_BANK]: 'PNC Bank',
  [documentSubtypes.NAVY_CREDIT_UNION]: 'Navy Credit Union',
  [documentSubtypes.CHIME]: 'Chime Bank',
  [documentSubtypes.US_BANK]: 'US Bank',
};

export const getDocumentSubtypeText = (type) => {
  const findText = text[type];
  if (findText) {
    return findText;
  } else {
    return type
      .toLowerCase()
      .split('_')
      .map(function (word) {
        if (word === 'and') {
          return '&';
        } else {
          return word.replace(word[0], word[0].toUpperCase());
        }
      })
      .join(' ');
  }
};
